module.exports = __webpack_public_path__ + "img/20.83e615bf.png";